import React, { useEffect, useState } from "react";
import { FaMotorcycle, FaMapMarkedAlt } from "react-icons/fa";
import { MdDeliveryDining, MdLocationOn } from "react-icons/md";
import { BsBoxSeamFill } from "react-icons/bs";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../api/request";
import { useSelector } from "react-redux";

const DeliveryPartnerDashboard = () => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const [assignedOrders, setAssignedOrders] = useState(null);

  useEffect(() => {
    performRequest(
      "GET",
      `pmg/delivery-partner/get-delivery-partnerId/${store.UserId}`
    )
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/pmg/delivery-partner/assigned-orders/${8}`)
      .then((res) => {
        if (res.status == 200) {
          console.log(res);
          setAssignedOrders(res?.data.assignedOrders);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          {/* Header */}
          <div className="page-header d-print-none m-0">
            <div className="col d-flex justify-content-between">
              <div>
                <h2 className="page-title mb-1 mt-4">
                  <FaMotorcycle className="me-2" />
                  Delivery Partner Dashboard
                </h2>
                <h4 className="text-muted m-0 p-0">
                  Manage deliveries and track orders
                </h4>
              </div>

              <div className="mt-4">
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate(-1)}
                >
                  <IoIosArrowBack /> Back
                </button>
              </div>
            </div>
          </div>

          {/* Statistics */}
          <div className="row mt-4">
            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body text-center">
                  <BsBoxSeamFill size={35} />
                  <h2 className="mt-2">8</h2>
                  <p className="text-muted mb-0">Assigned Orders</p>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body text-center">
                  <MdDeliveryDining size={40} />
                  <h2 className="mt-2">3</h2>
                  <p className="text-muted mb-0">Out For Delivery</p>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body text-center">
                  <FaMotorcycle size={35} />
                  <h2 className="mt-2">15</h2>
                  <p className="text-muted mb-0">Delivered Today</p>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card">
                <div className="card-body text-center">
                  <MdLocationOn size={35} />
                  <h2 className="mt-2 text-success">Available</h2>
                  <p className="text-muted mb-0">Current Status</p>
                </div>
              </div>
            </div>
          </div>

          {/* Orders + Tracking */}
          <div className="row">
            {/* Orders */}
            <div className="col-md-8 mb-3">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Assigned Orders</h3>
                </div>

                <div className="table-responsive">
                  <table className="table table-vcenter card-table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Customer</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {assignedOrders &&
                        assignedOrders.map((el) => {
                          return (
                            <tr>
                              <td>{el.orderId}</td>
                              <td>{el?.epg_order?.user?.userName}</td>
                              <td>{el?.epg_order?.deliveryAddress?.city}</td>
                              <td>
                                <span className="badge bg-warning">
                                  Assigned
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    navigate("/view-order-assigns/307/6")
                                  }
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-md-4 mb-3">
              <div className="card mb-3">
                <div className="card-header">
                  <h3 className="card-title">Delivery Partner Info</h3>
                </div>

                <div className="card-body">
                  <div className="mb-2">
                    <strong>Name:</strong> Rahul Patil
                  </div>

                  <div className="mb-2">
                    <strong>Mobile:</strong> 9876543210
                  </div>

                  <div className="mb-2">
                    <strong>Vehicle:</strong> Bike
                  </div>

                  <div className="mb-2">
                    <strong>Vehicle No:</strong> MH12AB1234
                  </div>
                </div>
              </div>

              <div className="card mb-3">
                <div className="card-header">
                  <h3 className="card-title">Live Tracking</h3>
                </div>

                <div className="card-body">
                  <div className="mb-2">
                    <strong>Latitude:</strong> 19.0760
                  </div>

                  <div className="mb-2">
                    <strong>Longitude:</strong> 72.8777
                  </div>

                  <button
                    className="btn btn-success w-100 mb-2"
                    onClick={() => navigate("/delivery-partner/track-order/1")}
                  >
                    Start Tracking
                  </button>

                  <button className="btn btn-danger w-100">
                    Stop Tracking
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Delivery Summary */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Today's Summary</h3>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <h2>15</h2>
                      <p className="text-muted">Delivered Orders</p>
                    </div>

                    <div className="col-6">
                      <h2>2</h2>
                      <p className="text-muted">Pending Orders</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Quick Actions</h3>
                </div>

                <div className="card-body d-flex gap-2">
                  <button className="btn btn-primary">My Orders</button>

                  <button
                    className="btn btn-success"
                    onClick={() => navigate("/delivery-partner/track-order/1")}
                  >
                    <FaMapMarkedAlt className="me-1" />
                    Open Map
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DeliveryPartnerDashboard;
